var Rating = function Rating(_ref) {
  var spacing = _ref.spacing,
      colors = _ref.colors;
  return {
    backgroundColor: colors.energy,
    icon: {
      size: 12
    },
    gutter: spacing.xxxsmall
  };
};

export default Rating;